<script setup lang="ts">
</script>

<template>
    <UINotifications />
</template>
